import { Dispatch } from 'redux';
import { IMainPage, IMainPageAction } from '../../../models/mainpage';

import { IMakeRequest } from '../../../helpers/network_helper';
import { IReduxContext } from '../../store';

export const GET_REQUEST = 'mainpage/GET_REQUEST';
export const GET_SUCCESS = 'mainpage/GET_SUCCESS';
export const GET_FAILURE = 'mainpage/GET_FAILURE';

export const EXPERIMENTS_GET_SUCCESS = 'mainpage/EXPERIMENTS_GET_SUCCESS';

const initialState: IMainPage = {
  agencies: [],
  contentPartData: [],
  developers: [],
  geoSeoLinks: [],
  isFetching: false,
  newSeoUrls: [],
  promoBlocks: [],
  realtors: [],
  regionsData: {
    cities: [],
    regions: [],
    subdomainCityId: 0,
    subdomainRegionAllowed: true,
    subdomainRegionCoordinates: undefined,
    subdomainRegionId: 0,
    subdomainRegionInflectedTitle: '',
    subdomainRegionInflectedTitleLoct: '',
    subdomainRegionTitle: '',
  },
  section: '',
  seoData: {
    description: '',
    h1: '',
    keywords: '',
    seoText: [],
    seoTextHeading: '',
    title: '',
  },
  top3: [],
  urls: {
    addform: '',
    agencies: '',
    developers: '',
    jks: '',
    realtors: '',
  },
};

const defaultAction: IMainPageAction = {
  type: '',
};

export const mainpageReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case GET_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        section: action.section,
      });

    case GET_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
      }, action.mainpage);

    case GET_FAILURE:
      return Object.assign({}, state, {
        error: true,
        isFetching: false,
      });

    case EXPERIMENTS_GET_SUCCESS:
      return Object.assign({}, state, {
        experiments: action.experiments,
      });

    default:
      return state;
  }
};

export const mainpageRequest = (section?: string): IMainPageAction => {
  return {
    type: GET_REQUEST,
    section,
  };
};

export const experimentsSuccess = (data: { experiments: {}}): IMainPageAction => {
  return {
    experiments: data.experiments,
    type: EXPERIMENTS_GET_SUCCESS,
  };
};

export const mainpageSuccess = (response: { data: IMainPage }): IMainPageAction => {
  return {
    mainpage: response.data,
    type: GET_SUCCESS,
  };
};

export const mainpageFailure = (): IMainPageAction => {
  return {
    type: GET_FAILURE,
  };
};

const getMainpageData = (section: string, host: string, dispatch: Dispatch<any>, context: IReduxContext) =>
  context.makeRequest(
    {
      method: 'GET',
      uri: {
        host,
        path: `/cian-api/site/v1/get-${section}-data-v2/`,
      },
    })
    .then((res: { data: IMainPage }) => {
      dispatch(mainpageSuccess(res));
    })
    .catch((err: Error) => {
        dispatch(mainpageFailure());
        throw err;
      },
    );

export const getExperimentsFlags = (
  dispatch: Dispatch<any>,
  makeRequest: IMakeRequest,
  activeExperiments: string[],
  cookie: string,
  queryString?: string,
) => {
  const apiBaseUrl = '/cian-api/site/v1/get-ab-experiments/';

  const experimentsParams = activeExperiments.reduce(
    (acc, experimentName, index, arr) =>
      acc += `experiments=${experimentName}${index < arr.length - 1 ? '&' : ''}`,
    '',
  );

  return makeRequest(
    {
      headers: [
        ['Cookie', cookie],
      ],
      method: 'GET',
      uri: {
        path: `${apiBaseUrl}?${experimentsParams}${experimentsParams && queryString ? '&' : ''}${queryString}`,
      },
    })
    .then((res: { data: { experiments: {}} }) => {
      dispatch(experimentsSuccess(res.data));
    })
    .catch((err: Error) => {
      throw err;
    });
};

export const ACTIVE_EXPERIMENTS = [
  'mainpage_newbuilding_search',
  'ab_newbuilding_search_tabs',
  'countryside_orthodox_parish',
];

export const getMainpage = (section: string, host = '', query?: {[x: string]: string}) => {
  return (dispatch: Dispatch<any>, getState: () => {}, context: IReduxContext) => {
    dispatch(mainpageRequest(section));

    return Promise.all([
      getMainpageData(section, host, dispatch, context),
    ]);
  };
};
